// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__syCxi","inputWrap":"CustomTip_inputWrap__icJHy"};